import get from "lodash/get"
import React, { useEffect, useState } from "react"
import Select from "react-select"
import { Link } from "react-router-dom"
import MetaTags from "react-meta-tags"
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Input,
  CardImg,
  CardSubtitle,
  Col,
  Container,
  Form,
  Label,
  Row,
} from "reactstrap"
import { withRouter } from "react-router-dom"

import { useSelector, useDispatch } from "react-redux"

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"
import { apiError, removeError } from "store/actions"
import FieldValidation from "../../../components/Common/FieldValidation"
import { isEmpty } from "lodash"
import { getAllShopsCall } from "../../../helpers/repository"
import { mapDataForDropDown } from "helpers/helpers"
import { createCashier } from "../../../store/cashier/actions"
import {sitename} from "../../../constants/constants";
const Create = props => {
  const dispatch = useDispatch()
  const [username, set_username] = useState("")
  const [password, set_password] = useState("")
  const [daily_limit, set_daily_limit] = useState("")
  const [shop_id, set_shop_id] = useState("")
  const [shops, set_shops] = useState("")
  const [selected_shop, set_selected_shop] = useState({
    label: "",
    value: "",
  })

  useEffect(() => {
    dispatch(apiError(""))
    getAllShopsCall().then(response => {
      set_shops(response?.data?.data)
    })
  }, [])
  const handleSubmit = e => {
    e.preventDefault()
    const data = {
      username: username,
      password: password,
      shop_id: shop_id,
      daily_limit: daily_limit,
    }

    dispatch(createCashier(data, props.history))
  }

  const formErrors = useSelector(state => state?.CommonState)
  const removeError = key => {
    let e = _.cloneDeep(formErrors)
    delete e[key]
    dispatch(apiError(e))
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{sitename}</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title="Bonuses" breadcrumbItem="Create" />
          <Card>
            <h5 className="card-header bg-transparent border-bottom text-uppercase">
              Create Cashier
            </h5>

            <CardBody>
              <Form onSubmit={handleSubmit}>
                <div className="row mb-4">
                  <Label
                    htmlFor="cashier_user_name_input"
                    className="col-sm-3 col-form-label"
                  >
                    User Name
                  </Label>
                  <Col sm={5}>
                    <Input
                      type="text"
                      maxLength="20"
                      name="username"
                      onChange={e => {
                        removeError("username")
                        set_username(e.target.value)
                      }}
                      value={username}
                      id={"cashier_user_name_input"}
                    />
                    {formErrors?.username ? (
                      <FieldValidation errorMessage={formErrors?.username} />
                    ) : null}
                  </Col>
                </div>

                <div className="row mb-4">
                  <Label
                    htmlFor="cashier_password_input"
                    className="col-sm-3 col-form-label"
                  >
                    Password
                  </Label>
                  <Col sm={5}>
                    <Input
                      type="password"
                      name="password"
                      onChange={e => {
                        removeError("password")
                        set_password(e.target.value)
                      }}
                      value={password}
                      id={"cashier_password_input"}
                    />
                    {formErrors?.password ? (
                      <FieldValidation errorMessage={formErrors?.password} />
                    ) : null}
                  </Col>
                </div>

                <div className="row mb-4">
                  <Label
                    htmlFor="cashier_daily_limit_input"
                    className="col-sm-3 col-form-label"
                  >
                    Daily Limit
                  </Label>
                  <Col sm={5}>
                    <Input
                      type="text"
                      name="daily_limit"
                      maxLength="20"
                      onChange={e => {
                        removeError("daily_limit")
                        set_daily_limit(e.target.value)
                      }}
                      value={daily_limit}
                      id={"cashier_daily_limit_input"}
                    />
                    {formErrors?.daily_limit ? (
                      <FieldValidation errorMessage={formErrors?.daily_limit} />
                    ) : null}
                  </Col>
                </div>

                <div className="row mb-4">
                  <Label
                    htmlFor="shops_dropdown"
                    className="col-sm-3 col-form-label"
                  >
                    Shops
                  </Label>
                  <Col sm={5}>
                    <Select
                      id="shops_dropdown"
                      maxMenuHeight={150}
                      onChange={agent => {
                        removeError("shops")
                        set_selected_shop(agent)
                        set_shop_id(agent?.id)
                      }}
                      options={mapDataForDropDown(shops)}
                      classNamePrefix="select2-selection"
                      value={{
                        label: selected_shop?.label,
                        value: selected_shop?.value,
                      }}
                    />
                    {formErrors?.selected_shop ? (
                      <FieldValidation
                        errorMessage={formErrors?.selected_shop}
                      />
                    ) : null}
                  </Col>
                </div>

                <div className="row">
                  <Col sm={3}></Col>
                  <Col sm={9}>
                    <Row>
                      <Col sm={4} xs={6} md={4} lg={3} xl={2}>
                        <Button type="submit" color="primary" className="w-100">
                          Submit
                        </Button>
                      </Col>
                      <Col sm={4} xs={6} md={4} lg={3} xl={2}>
                        <Button
                          type="button"
                          color="secondary"
                          className="w-100"
                          onClick={() => {
                            props.history.push("/admin/cashiers")
                          }}
                        >
                          Cancel
                        </Button>
                      </Col>
                      <Col sm={4} md={4} lg={6} xl={8}></Col>
                    </Row>
                  </Col>
                </div>
              </Form>
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  )
}
export const CreateCashier = withRouter(Create)
